module.exports = __webpack_public_path__ + "static/media/paperplane.d23520d5.svg";